module.exports = __webpack_public_path__ + "img/Banner-Web_1360.55495d04.jpg";